import React, {useState, useEffect} from "react";

import "./LogLevels.css";
import {Accordion} from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import {reverse_syslog_subsystems, syslog_levels} from "./bondLevels";
import {
    faFilter, faX, faBarsProgress
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InputGroup from "react-bootstrap/InputGroup";

window.loadingLogLevels = false;

function LogLevels({bondApi}) {
    const [searchQuery, setSearchQuery] = useState("");

    const [logLevelData, setLogLevelData] = useState(null);
    const [logLevelsElements, setLogLevelElements] = useState(null);
    const [loadingLogLevels, setLoadingLogLevels] = useState(true);

    useEffect(() => {
        if (bondApi && !window.loadingLogLevels) {
            window.loadingLogLevels = true;
            getLogLevels().finally(() => {
                window.loadingLogLevels = false
            });
        }
    }, [bondApi])

    useEffect(() => {
        renderLogLevels();
    }, [logLevelData, loadingLogLevels]);

    async function getLogLevels() {
        const response = await bondApi.logLevels();
        setLogLevelData(response.subsys_lvl);
        setLoadingLogLevels(false);
    }

    function onLogLevelChange(logLvl, subsys) {
        setLoadingLogLevels(true);
        bondApi.setLogLevel(subsys, logLvl).then((response) => {
            getLogLevels();
        }).catch(() => {
            setLoadingLogLevels(false);
        });
    }

    function renderLogLevels() {
        if (!logLevelData) return;
        let elements = [];
        for (let i = 0; i < logLevelData.length; i++) {
            elements.push(<Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword" key={"subsys_log" + i}
                                      disabled={loadingLogLevels}>
                <Form.Label xs="7" column="md">
                    [{i}] {reverse_syslog_subsystems[i]}
                </Form.Label>
                <Col xs="5">
                    <Form.Select
                        value={logLevelData[i]}
                        disabled={loadingLogLevels}
                        onChange={(e) => onLogLevelChange(e.target.value, i)}
                    >
                        {Object.entries(syslog_levels).map(([key, value]) => (<option key={value} value={value}>
                            {key}
                        </option>))}
                    </Form.Select>
                </Col>
            </Form.Group>)
            setLogLevelElements(elements);
        }
    }

    const filteredLogLevelsElements = logLevelsElements?.filter(element => {
        const subsysValue = element.props.children[0].props.children.join("").toLowerCase();
        return subsysValue.includes(searchQuery.toLowerCase());
    });

    return (<Accordion className="livelogAccordion">
        <Accordion.Item eventKey="0">
            <Accordion.Header>
                <FontAwesomeIcon icon={faBarsProgress} size="xl" className="iconAccordionHeader"/>
                Log Levels
            </Accordion.Header>
            <Accordion.Body>
                <Form.Group as={Row} className="mb-3 sticky-top">
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faFilter}/>
                        </InputGroup.Text>
                        <Form.Control
                            aria-describedby="basic-addon1"
                            type="text"
                            placeholder=""
                            autoComplete="logSubsysFilter"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <Button variant="outline-secondary inputSideBtn" id="button-addon2"
                                onClick={(e) => setSearchQuery("")}>
                            <FontAwesomeIcon icon={faX}/>
                        </Button>
                    </InputGroup>

                </Form.Group>
                {filteredLogLevelsElements}
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>);
}

export default LogLevels;


